import { SvgIconTypeMap } from '@mui/material';

interface NegativeSentimentIconProps {
  color?: SvgIconTypeMap['props']['color'];
}

export const NegativeSentimentIcon = ({
  color,
}: NegativeSentimentIconProps) => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96001 13.345L10.5758 9.72272C10.8177 9.4808 10.955 9.14734 10.955 8.8008V2.26887C10.955 1.54964 10.3665 0.961182 9.64732 0.961182H3.76924C3.24616 0.961182 2.77539 1.27503 2.5727 1.75234L0.441164 6.7281C-0.114606 8.02272 0.833471 9.46118 2.23924 9.46118H5.93347L5.31232 12.4558C5.24693 12.7827 5.34501 13.1162 5.58039 13.3516C5.96616 13.7308 6.58078 13.7308 6.96001 13.345ZM13.5769 0.961182C12.8577 0.961182 12.2692 1.54964 12.2692 2.26887V7.49964C12.2692 8.21887 12.8577 8.80734 13.5769 8.80734C14.2962 8.80734 14.8846 8.21887 14.8846 7.49964V2.26887C14.8846 1.54964 14.2962 0.961182 13.5769 0.961182ZM19.9518 15.9759C19.9518 19.2339 17.3107 21.875 14.0528 21.875C10.7948 21.875 8.1537 19.2339 8.1537 15.9759C8.1537 12.7179 10.7948 10.0768 14.0528 10.0768C17.3107 10.0768 19.9518 12.7179 19.9518 15.9759ZM17.9204 13.3393C17.9204 12.9133 17.5758 12.5648 17.1499 12.5648H10.9542C10.5282 12.5648 10.1797 12.9133 10.1797 13.3393V17.9861C10.1797 18.412 10.5282 18.7605 10.9542 18.7605H16.3754L17.9243 20.3094L17.9204 13.3393ZM15.9882 17.2116H12.1159C11.9029 17.2116 11.7286 17.0373 11.7286 16.8244C11.7286 16.6114 11.9029 16.4371 12.1159 16.4371H15.9882C16.2011 16.4371 16.3754 16.6114 16.3754 16.8244C16.3754 17.0373 16.2011 17.2116 15.9882 17.2116ZM15.9882 16.0499H12.1159C11.9029 16.0499 11.7286 15.8757 11.7286 15.6627C11.7286 15.4497 11.9029 15.2754 12.1159 15.2754H15.9882C16.2011 15.2754 16.3754 15.4497 16.3754 15.6627C16.3754 15.8757 16.2011 16.0499 15.9882 16.0499ZM15.9882 14.8882H12.1159C11.9029 14.8882 11.7286 14.714 11.7286 14.501C11.7286 14.288 11.9029 14.1138 12.1159 14.1138H15.9882C16.2011 14.1138 16.3754 14.288 16.3754 14.501C16.3754 14.714 16.2011 14.8882 15.9882 14.8882Z"
        fill={color}
      />
    </svg>
  );
};
